import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.crawl.detail');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-crawl-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.crawl.detail/view.scss */
:host {
  display: block;
  height: 100%;
}

.page-wrap {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px;
}`],
})
export class PageCrawlDetailComponent implements OnInit {
    public WizRoute: any;

    constructor(@Inject( Service) public service: Service) { }

    public notice: any = null;
    public noticeId: string = '';
    public scrapped: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        this.noticeId = WizRoute.segment.id || '';

        let stored = localStorage.getItem('crawl_notice');
        if (stored) {
            try {
                let data = JSON.parse(stored);
                if (data.notice_no === this.noticeId) {
                    this.notice = data;
                }
            } catch { }
        }

        if (!this.notice) {
            this.service.href('/crawl');
            return;
        }

        await this.checkScrapped();
        await this.service.render();
    }

    private async checkScrapped() {
        try {
            let res = await wiz.call("is_scrapped", { notice_no: this.noticeId });
            if (res.code === 200) {
                this.scrapped = res.data.scrapped;
            }
        } catch { }
    }

    public async toggleScrap() {
        if (this.scrapped) {
            let res = await wiz.call("unscrap", { notice_no: this.noticeId });
            if (res.code === 200) this.scrapped = false;
        } else {
            let res = await wiz.call("scrap", { data: JSON.stringify(this.notice) });
            if (res.code === 200) this.scrapped = true;
        }
        await this.service.render();
    }

    public goBack() {
        history.back();
    }

    public async openProject() {
        if (!this.scrapped) {
            try {
                let res = await wiz.call("scrap", { data: JSON.stringify(this.notice) });
                if (res.code === 200) this.scrapped = true;
            } catch { }
        }
        this.service.href(`/analysis/${encodeURIComponent(this.noticeId)}?from=project`);
    }

    public openG2b() {
        if (this.notice?.detail_url) {
            window.open(this.notice.detail_url, '_blank');
        }
    }

    public getDday(deadline: string): number | null {
        if (!deadline) return null;
        try {
            let dt: Date;
            if (deadline.includes('-')) {
                dt = new Date(deadline);
            } else if (deadline.length >= 8) {
                let y = deadline.substring(0, 4);
                let m = deadline.substring(4, 6);
                let d = deadline.substring(6, 8);
                dt = new Date(`${y}-${m}-${d}`);
            } else {
                return null;
            }
            let now = new Date();
            now.setHours(0, 0, 0, 0);
            dt.setHours(0, 0, 0, 0);
            return Math.ceil((dt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
        } catch {
            return null;
        }
    }

    public getDdayColor(days: number | null): string {
        if (days === null) return 'text-stone-400';
        if (days <= 3) return 'text-red-500';
        if (days <= 7) return 'text-orange-500';
        if (days <= 14) return 'text-yellow-600';
        return 'text-emerald-600';
    }

    public getDdayBg(days: number | null): string {
        if (days === null) return 'bg-stone-100';
        if (days <= 3) return 'bg-red-50 border-red-200';
        if (days <= 7) return 'bg-orange-50 border-orange-200';
        if (days <= 14) return 'bg-yellow-50 border-yellow-200';
        return 'bg-emerald-50 border-emerald-200';
    }

    public getDdayText(days: number | null): string {
        if (days === null) return '-';
        if (days === 0) return 'D-Day';
        if (days > 0) return `D-${days}`;
        return `D+${Math.abs(days)}`;
    }

    public formatBudget(amount: number) {
        if (!amount) return '-';
        if (amount >= 100000000) return (amount / 100000000).toFixed(1) + '억원';
        if (amount >= 10000) return (amount / 10000).toFixed(0) + '만원';
        return amount.toLocaleString() + '원';
    }

    public formatFullBudget(amount: number) {
        if (!amount) return '-';
        return amount.toLocaleString() + '원';
    }

    public formatDate(dt: string) {
        if (!dt || dt.length < 8) return '-';
        if (dt.includes('-')) return dt.substring(0, 16);
        let y = dt.substring(0, 4);
        let m = dt.substring(4, 6);
        let d = dt.substring(6, 8);
        let h = dt.length >= 10 ? dt.substring(8, 10) : '00';
        let mi = dt.length >= 12 ? dt.substring(10, 12) : '00';
        return `${y}-${m}-${d} ${h}:${mi}`;
    }
}

export default PageCrawlDetailComponent;